import { useMemo } from 'react';
// @ts-ignore no types
import localeComparator from 'I18n/utils/localeComparator';
import { useGetAppGovernancePermissionsSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
import { AppPermissionInfo } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc';

const sortPermissionsByName = (permissions: AppPermissionInfo[] = []) => {
  return [...permissions].sort((a, b) => localeComparator(a.name, b.name));
};

export function useFetchModalPermissions() {
  const { appId } = useApp();
  const { error, data } = useGetAppGovernancePermissionsSuspenseQuery({
    variables: {
      appId,
    },
  });

  useCaptureError(error, {
    message: 'Error fetching modal permissions',
  });

  const sortedData = useMemo(() => {
    if (!data) {
      return data;
    }

    return {
      ...data,
      optionalAppPermissions: sortPermissionsByName(
        data.optionalAppPermissions
      ),
      requiredAppPermissions: sortPermissionsByName(
        data.requiredAppPermissions
      ),
      conditionallyRequiredAppPermissions: sortPermissionsByName(
        data.conditionallyRequiredAppPermissions
      ),
    };
  }, [data]);

  return { error, data: sortedData };
}
